import { useEffect, useState } from "react";
import { useLocation, useHistory, Route  } from "react-router-dom";
//---------------------------------------------------------------------
import Resize from "src/components/common/resize";
import Footer from "src/components/common/frame/footer";
import magnifierImg from "src/img/magnifier.png";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyFormData, boolAndReducer, getTimeStamp, appTitle, getDriveFolderId } from "src/components/common/functions";
import Form from "./form";
import SettingForm from "./settingForm";
//---------------------------------------------------------------------
export default function Training({ tabTitle }){
    //---------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    //---------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    const id = location.pathname.split("/")[2];
    //---------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const [rawData, setRawData] = useState({});
    const [showLoading, setShowLoading] = useState(true);
    const [trainings, setTrainings] = useState([]);
    const [renderSwitch, setRenderSwitch] = useState(true);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //---------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredTrainings = trainings.filter(u => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentPageItems = filteredTrainings.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredTrainings.length / itemsPerPage)}, (_, i) => (i + 1));
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const id = history.location.pathname.split("/")[2];
            // --- Read personal data -----------------------
            const formData = new MyFormData();
            formData.append("fileId", user.trainingId);
            // ------------------------
            setShowLoading(true);
            const res = await myAxios("common/getJSONData.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            // ------------------------
            setRawData(res.data || {});
            // ----------------------------------------------
            // --- Read personal data -----------------------
            if(user.projects === "no") return;
            const formData1 = new MyFormData();
            formData1.append("folderId", getDriveFolderId("training"));
            // ------------------------
            setShowLoading(true);
            const res1 = await myAxios("common/readFolder.php", formData1);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res1) return;
            // ------------------------
            setTrainings(res1.data);
            // ----------------------------------------------
            if(!res1.data.map(item => item.id).includes(id) && id !== undefined && id !== "Add") history.push("/Training");
            
        }
        getData();
        return () => isMounted = false
    }, [history, renderSwitch, updateDateTime])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //---------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Training
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {user.projects !== "no"?
                <span className = "pointer" onClick = {() => {history.push("/Training/Add")}}>Add</span>
                :null}
            </div>
                <div className = "cssContent pb10"> 
                    {showLoading?<div className = "cssLoading">Loading...</div>:
                    !filteredTrainings.length?<div className = "cssLoading">Empty</div>:
                    <div className = "table-responsive">
                        <table className = "table">
                            <thead className = "noTableTopBorder">
                                <tr>
                                    <th>Training Name</th>
                                    <th>Status</th>
                                    <th>Score</th>
                                    {user.projects !== "no"?<th></th>:null}
                                    {user.projects !== "no"?<th></th>:null}
                                </tr>
                            </thead>
                            <tbody>
                                {currentPageItems.map((training, trainingIndex) => 
                                <tr
                                    key = {trainingIndex}
                                    id = {training.id}
                                    className = "pointer "
                                    onClick = {e =>{
                                        if(!e.target.id){
                                            history.push(`/Training/${training.id}/Run`);
                                        }
                                    }}
                                >
                                    <td className = "text-primary">{training.name}</td>
                                    <td>{rawData[training.id]?.status}</td>
                                    <td>{rawData[training.id]?.status === "Passed" || rawData[training.id]?.status === "Failed"?rawData[training.id].curScore + " / " + rawData[training.id].totalScore:null}</td>
                                    {user.projects !== "no"?<td><span id = {training.id + " Edit"} className = "btn btn-primary" onClick = {() => {history.push(`/Training/${training.id}/Edit`)}}>Edit</span></td>:null}
                                    {user.projects !== "no"?<td><span id = {training.id + " Delete"} className = "btn btn-danger" onClick = {async() => {
                                        if(!window.confirm("Are you sure to delete this training?")) return;
                                        const formData = new MyFormData();
                                        formData.append("fileId", training.id);
                                        //-------------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("common/deleteFile.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //-------------------------------------------------------------
                                        setRenderSwitch(s => !s);
                                    }}>Delete</span></td>:null}
                                </tr>)}
                            </tbody>
                        </table>
                    </div>}
                    {!showLoading && filteredTrainings.length?
                    <Footer
                        length = {filteredTrainings.length}
                        pageNumbers = {pageNumbers}
    
                        currentPage = {currentPage}
                        setCurrentPage = {setCurrentPage}
                        itemsPerPage = {itemsPerPage}
                        setItemsPerPage = {setItemsPerPage}
                    />
                    :null}
                </div>
        <Route path = {`/Training/${id}/Run`} children = {
            trainings.length > 0?<Form
            closeIt = {() => history.push("/Training")}
            setRenderSwitch = {setRenderSwitch}
            rawData = {rawData}
            id = {id} 
        />:null}
        />
        <Route path = {`/Training/Add`} children = {
            trainings.length > 0?<SettingForm
            keyword = "Add Training" 
            closeIt = {() => history.push("/Training")}
            setRenderSwitch = {setRenderSwitch}
        />:null}
        />
        <Route path = {`/Training/${id}/Edit`} children = {
            trainings.length > 0?<SettingForm
            keyword = "Settings" 
            closeIt = {() => history.push("/Training")}
            setRenderSwitch = {setRenderSwitch}
            id = {id} 
        />:null}
        />
        </div>
    )
}